import { useState } from "react";
import { useParams } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Terminal, Gamepad2, RefreshCw, Power, Loader2, MoreVertical, ShieldCheck, Tags, X } from "lucide-react";
import { toast } from "sonner";
import UnenrollDevice from "./UnenrollDevice";
import { useNotifications } from "@/contexts/NotificationContext";
import { TagAssignmentDialog } from "@/components/tags/TagAssignmentDialog";
import { TagRemovalDialog } from "@/components/tags/TagRemovalDialog";
import * as devicesApi from "@/services/devicesApi";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem,
  DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

const DeviceActions = () => {
  const { id: deviceId } = useParams();
  const { addNotification } = useNotifications();
  const [isTagAssignmentOpen, setIsTagAssignmentOpen] = useState(false);
  const [isTagRemovalOpen, setIsTagRemovalOpen] = useState(false);

  const triggerHeartbeat = async () => {
    if (!deviceId) return;
    try {
      await devicesApi.checkInDevice({ deviceId } as any);
      toast.success('Device heartbeat triggered successfully');
    } catch (error) {
      console.error('Error in triggerHeartbeat:', error);
      toast.error('Failed to trigger device heartbeat');
    }
  };

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="ghost" size="icon" className="h-8 w-8" aria-label="Actions">
            <MoreVertical className="h-4 w-4" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="w-56">
          <DropdownMenuLabel>Remote Access</DropdownMenuLabel>
          <DropdownMenuItem onClick={() => toast.info('Remote Terminal — Coming Soon')}>
            <Terminal className="mr-2 h-4 w-4" />
            Remote Terminal
          </DropdownMenuItem>
          <DropdownMenuItem onClick={() => toast.info('Remote Control — Coming Soon')}>
            <Gamepad2 className="mr-2 h-4 w-4" />
            Remote Control
          </DropdownMenuItem>
          
          <DropdownMenuSeparator />
          <DropdownMenuLabel>Management</DropdownMenuLabel>
          <DropdownMenuItem onSelect={(e) => { e.preventDefault(); setIsTagAssignmentOpen(true); }}>
            <Tags className="mr-2 h-4 w-4" />
            Assign Tags
          </DropdownMenuItem>
          <DropdownMenuItem onSelect={(e) => { e.preventDefault(); setIsTagRemovalOpen(true); }}>
            <X className="mr-2 h-4 w-4" />
            Remove Tags
          </DropdownMenuItem>
          
          <DropdownMenuSeparator />
          <DropdownMenuLabel>System</DropdownMenuLabel>
          <DropdownMenuItem onClick={triggerHeartbeat}>
            <RefreshCw className="mr-2 h-4 w-4" />
            Check In
          </DropdownMenuItem>
          {deviceId && (
            <DropdownMenuItem onSelect={(e) => e.preventDefault()} className="text-destructive focus:text-destructive">
              <UnenrollDevice deviceId={deviceId} deviceName={deviceId} />
            </DropdownMenuItem>
          )}
        </DropdownMenuContent>
      </DropdownMenu>

      {deviceId && (
        <>
          <TagAssignmentDialog
            open={isTagAssignmentOpen}
            onOpenChange={setIsTagAssignmentOpen}
            resourceId={deviceId}
            resourceType="device"
            resourceName={deviceId}
            onAssignmentComplete={() => setIsTagAssignmentOpen(false)}
          />
          <TagRemovalDialog
            open={isTagRemovalOpen}
            onOpenChange={setIsTagRemovalOpen}
            deviceId={deviceId}
            deviceName={deviceId}
            onRemovalComplete={() => setIsTagRemovalOpen(false)}
          />
        </>
      )}
    </>
  );
};

export default DeviceActions;
